import { defineStore } from 'pinia';
import { ref } from 'vue';

type GamesState = {
  matchThePairs?: null;
};

type AudioResource = {
  id: string;
  url: string;
};

const useGamesStore = defineStore('games', () => {
  const gameState = ref<GamesState>({
    matchThePairs: null,
  });

  const audios = ref<AudioResource[]>([]);
  const setAudio = (audio: AudioResource) => {
    audios.value.push(audio);
  };
  const getAudio = (id: string) => audios.value.find((item) => item.id === id);

  return {
    gameState,
    audios,
    setAudio,
    getAudio,
  };
});

export default useGamesStore;
